import React from "react";

// AXİOS
import { kurumdelete } from "../../../../axios/axios";

// BİLDİRİM İÇİN PAKET
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// FONT AWASOME İCON PAKETİ
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons';


const AdminCompanyDelete = (props) => {

    const handleDelete = async (id, kurumAdı) => {
        const confirmDelete = window.confirm(`${kurumAdı} adlı kurumu silmek istediğinize emin misiniz ?`);
        if (confirmDelete) {
            kurumdelete(id)
                .then((res) => {
                    toast.success("Kurum Başarıyla Silindi !")
                    console.log(res.data)
                })
                .catch((err) => toast.error("Kurum Silme Başarısız !", err.response.data.message));
        }
    }

    return (
        <>
            <FontAwesomeIcon style={{ fontSize: "20px" }}
                onClick={() => handleDelete(props.deleteBilgiler._id, props.deleteBilgiler.kurumAdı)}
                className="me-3"
                icon={faTrash}
                size="1x" />
        </>
    );

};
export default AdminCompanyDelete;
